<script>
import ButtonControl from '../RangeSlider/ButtonControl.vue';
import RangeSlider from '../RangeSlider/RangeSlider.vue';
import ToggleSwitch from '../ToggleSwitch/ToggleSwitch.vue';

export default {
  name: 'FormFilter',
  components: {
    ButtonControl,
    RangeSlider,
    ToggleSwitch,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    fields: {
      type: Array,
      required: true,
    },
    metrics: {
      type: Array,
      required: true,
    },
  },
  data: function() {
    return {
      id: null,
      label: null,
      activeField: null,
      activeMetric: null,
      activeRange: null,
      currentValue: 0,
    };
  },
  computed: {
    fieldCount: function() {
      return this.fields.length;
    },
    metricCount: function() {
      return this.metrics.length;
    },
  },
  updated() {
    this.setActiveField();
  },
  mounted() {
    this.setActiveField();
  },
  methods: {
    // this component is a composite of multiple fields and metrics
    // so we need to map its data to the 'active' versions of each
    setActiveField: function() {
      if (!this.fields.length || !this.metrics.length) return;

      this.activeField = this.fields[0];
      this.label = this.activeField.label;

      this.fields.forEach(field => {
        this.metrics.forEach(metric => {
          if (field.metric === metric.id) {
            this.activeMetric = metric;
            this.currentValue = metric.value;
            this.activeRange = metric.range;
            this.id = metric.name;
          }
        });
      });
    },
    subFieldChange: function([, name]) {
      this.fields.forEach((field, index) => {
        if (field.name === name) {
          this.activeField = index;
        }
      });
      this.change();
    },
    isActive: function(id) {
      return id === this.active;
    },
    change: function() {
      this.$emit('filterChange', this.activeField.id, this.activeMetric.id, this.currentValue, this.activeRange);
    },
    rangeChange: function([, value]) {
      this.currentValue = value;
      this.change();
    },
    fieldNames: function() {
      return this.fields.map(subField => ({
        label: subField.label,
        value: subField.name,
      }));
    },
    metricNames: function() {
      return this.metrics.map(metric => ({
        label: metric.displayName,
        value: metric.id,
      }));
    },
    metricChange: function(newMetric) {
      this.metrics.forEach(metric => {
        if (metric.id === newMetric) {
          this.activeMetric = metric;
        }
      });
      this.change();
    },
  },
};
</script>
<template>
  <div v-if="activeMetric" class="form-finder__setting-wrap">
    <div class="form-finder__setting-label">
      <label :for="id">{{ label }}</label>
      <span class="range-slider__sub-label">Max strike rate {{ activeMetric.maxValue }}%</span>
    </div>
    <div v-if="metricCount > 1" class="form-finder__setting-additional-element">
      <ButtonControl
        :buttons="metricNames()"
        :active="activeMetric.id"
        name="button"
        @input="metricChange"
      />
    </div>
    <RangeSlider
      :min="activeMetric.minValue"
      :max="activeMetric.maxValue"
      :value="currentValue"
      :step="activeMetric.increments"
      :name="activeField.id"
      :label="name"
      @change="rangeChange"
    />
    <div class="form-finder__setting-additional">
      <div v-if="fieldCount > 1" class="form-finder__setting-additional-element">
        <ButtonControl
          :buttons="fieldNames()"
          :active="activeField.id"
          name="button"
          @input="subFieldChange"
        />
      </div>
    </div>
  </div>
</template>
